import { Link } from "@tanstack/react-router";

/**
 * Google Health OAuth step sync has been discontinued, so this callback can
 * no longer be reached from a live "Connect" flow. It's kept as a friendly
 * landing page (rather than removed) in case any in-flight redirect from
 * Google still lands here during the rollout.
 */
export default function GoogleHealthCallback() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-8 flex-col gap-3">
      <p className="text-5xl mb-2">👟</p>
      <p className="text-text text-xl font-extrabold text-center">
        Google Health sync is no longer supported
      </p>
      <p className="text-text-muted text-base text-center leading-6 max-w-md">
        We&apos;ve discontinued Google Health step sync. Download the FootSlapping iOS or Android
        app to sync your steps through Apple Health or Health Connect.
      </p>
      <Link
        to="/settings"
        className="bg-aqua rounded-2xl py-3 px-6 items-center justify-center shadow-[1px_1px_0px_0px_#1c1b2e] border border-text no-underline inline-flex font-inherit cursor-pointer mt-2"
      >
        <span className="text-white font-extrabold text-sm">Go to settings</span>
      </Link>
    </div>
  );
}
